import { ScriptHackComponent } from './../script-hack/script-hack.component';
import { RouterModule } from '@angular/router';
import { MaterialModule } from './../../app_mobile/material.module';
import { HttpClientModule } from '@angular/common/http';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { BannerZoneMapComponent } from './banner-zone-map.component';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,
    MaterialModule,
    RouterModule,
  ],
  declarations: [BannerZoneMapComponent,ScriptHackComponent],
  exports: [BannerZoneMapComponent]
})
export class BannerZoneMapModule { }